export const APPLICATIONS = Object.freeze({
  TGONE: "tgone",
  CEMEDI: "cemedi",
});

export const isDeviceVisibleInApplication = (device, application) => {
  if (!device) return false;
  if (application === APPLICATIONS.CEMEDI) return Boolean(device.bl_cemedi);
  if (application === APPLICATIONS.TGONE) return Boolean(device.bl_tgone);
  return false;
};

export const hasAtLeastOneApplication = (device = {}) =>
  Boolean(device.bl_tgone || device.bl_cemedi);

export const buildViewerPath = (deviceSectionId) =>
  deviceSectionId
    ? `/viewer?id=${encodeURIComponent(deviceSectionId)}`
    : "/viewer";

export const resolveViewerDeviceSectionId = (item) =>
  item?.id_sectionDevice
  || item?.id_dispositivoSeccion
  || item?.dispositivoSeccion?.id
  || item?.dispositivo?.id
  || null;

// Favoritos históricamente abría el visor con el id de la relación expandida
// `dispositivo`. Se conserva esa precedencia porque algunas respuestas antiguas
// incluyen un id_sectionDevice distinto al registro que acepta service.get(id).
export const resolveFavoriteViewerId = (item) =>
  item?.dispositivo?.id
  || resolveViewerDeviceSectionId(item);

export const hasApplicationVisibilityFields = (device = {}) =>
  Object.prototype.hasOwnProperty.call(device, "bl_tgone")
  || Object.prototype.hasOwnProperty.call(device, "bl_cemedi");
